import { SVGProps } from 'react';

export const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7002 6.31858C20.1004 6.74282 20.0998 7.43005 19.699 7.85354L10.3943 17.6828C9.9937 18.106 9.34479 18.1057 8.94451 17.6821L4.3004 12.7675C3.89987 12.3436 3.89987 11.6564 4.3004 11.2325C4.70094 10.8086 5.35034 10.8086 5.75088 11.2325L9.67038 15.3803L18.2498 6.31722C18.6507 5.89373 19.3001 5.89434 19.7002 6.31858Z"
    />
  </svg>
);
